module.exports = __webpack_public_path__ + "static/img/hot-img.e7f02392.png";